export default {
    props: {
        sectionData: {
            type: Object,
            default: null
        }
    }
};
